module.exports = __webpack_public_path__ + "static/media/Jimmy-October.67ef91fb.jpg";